import React, { useCallback, useEffect, useMemo, useState, useContext } from "react";
import Layout from "../../Layout";
import SpaceCategoriesPaths from "../../components/SpaceCategoriesPaths";
import UploadDrag from "../../components/UploadDragger";
import PageList from "./PageList";
import Sidebar from "./sidebar";
import events from "../../context/events";
import context from "../../context";
import { folderType, folderTypeEnum } from "../../config/permissions.config";
import { MenuEnum } from "../../components/List/SharesFilters/config";
import ListPages from "./ListPages";
import TeamListShares from "./TeamListShares";
import { connect } from "dvajs";
import CardFolderList from "./CardFolderList";
import { Tabs } from "./config";
import { PermissionEnum } from "../../const";
import "../../common/index.less";
import "./index.less";
import { ErrorCode, ResetErrorCode } from "../../types";
import { PageRouteName } from "../../batchOperate";
function MySpace(props: any) {
  const [defalutSpaceId, setDefalutSpaceId] = useState<folderType | null>(null);
  const { currentRouterInfo } = useContext(context);
  const [desc, setDesc] = useState("");
  const [errorCode, setErrorCode] = useState("");
  useEffect(() => {
    setErrorCode("");
    if (!currentRouterInfo) {
      console.warn("currentRouterInfo_null_Error");
      return;
    }
    if (currentRouterInfo.type === folderTypeEnum.SHARE && defalutSpaceId !== folderType.SHARE) {
      setDefalutSpaceId(folderType.SHARE);
      return;
    }
    if (currentRouterInfo.type === folderTypeEnum.MY && defalutSpaceId !== folderType.MY) {
      setDefalutSpaceId(folderType.MY);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentRouterInfo]);
  const onShowFolderDesc = useCallback((desc) => {
    setDesc(desc);
  }, []);
  const handleErrorCode = useCallback((errorCode = "") => {
    setErrorCode(errorCode);
  }, []);
  const backTop = () => {
    const node = document.getElementsByClassName("myspace-list-wrap")[0];
    if (!node) {
      return;
    }
    node.scrollTop = 0;
  };
  // 滚条置顶只要作用修复这个bug 我的文件首页加载多页数据，然后切换到共享文件滚动条还是在之前位置。
  useEffect(() => {
    backTop();
  }, [currentRouterInfo]);
  useEffect(() => {
    // events.on("joyspce:errorCode", handleErrorCode);
    events.on("onShowFolderDesc", onShowFolderDesc);
    events.on("list.reload", backTop);
    return () => {
      //   events.off("joyspce:errorCode", handleErrorCode);
      events.off("onShowFolderDesc", onShowFolderDesc);
      events.off("list.reload", backTop);
    };
  }, [onShowFolderDesc]);
  const usePageList = useMemo(() => {
    return (
      <PageList
        diffHeight={desc ? 40 : 0}
        // 解决左侧导航快速切换时数据切换出错问题
        key={Math.floor(Math.random() * 1000)}
      />
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const permissions = useMemo(() => {
    if (currentRouterInfo?.id === "myspace") {
      return [PermissionEnum.PAGE_CREATE];
    } else if (currentRouterInfo?.permissions) {
      return currentRouterInfo.permissions || [];
    } else {
      return [];
    }
  }, [currentRouterInfo]);
  if (!currentRouterInfo) {
    return null;
  }
  return (
    <Layout>
      <div className="joyspace-drop">
        <UploadDrag
          toId={currentRouterInfo?.id}
          toName={currentRouterInfo?.name}
          from={
            currentRouterInfo?.type === folderTypeEnum.SHARE
              ? PageRouteName.TEAM_SPACE
              : PageRouteName.MY_SPACE
          }
          permissions={permissions}
        />
        <div>
          <div className={errorCode ? "joyspace-header joyspace-header-none" : "joyspace-header"}>
            {!errorCode && (
              <>
                <Layout.Breadcrumbs>
                  <SpaceCategoriesPaths name={defalutSpaceId || folderType.MY} />
                </Layout.Breadcrumbs>
                <Sidebar currentRouterInfo={currentRouterInfo} />
              </>
            )}
          </div>
          {/* 描述 */}
          {desc &&
            errorCode !== ResetErrorCode.noPermission &&
            errorCode !== ErrorCode.noPermission &&
            errorCode !== ResetErrorCode.Delete &&
            errorCode !== ErrorCode.Delete && (
              <div className="joyspace-breadcrumb-file-desc">{desc}</div>
            )}
        </div>
        {currentRouterInfo.hasOwnProperty("level") ? (
          <div className="myspace-list-wrap joyspace-card-ppup-container" id="right-wrap">
            <CardFolderList currentRouterInfo={currentRouterInfo} />
            <h3 className="myspace-list-title">
              {currentRouterInfo?.id === "myspace" ? "文件" : "分享给我的文件"}
            </h3>
            {currentRouterInfo.id === "myspace" ? (
              <ListPages />
            ) : (
              <TeamListShares activeKey={Tabs.SHARES} defaultFilter={MenuEnum.PATH} />
            )}
          </div>
        ) : (
          usePageList
        )}
      </div>
    </Layout>
  );
}
function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch: any) {
  return {
    setCurrentRouterInfoById(data: any) {
      dispatch({ type: "joyspace/setCurrentRouterInfoById", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(MySpace);
